/* eslint-disable no-unused-vars */
import { takeEvery, all } from 'redux-saga/effects';

export default function* watch() {
	//yield all([takeEvery()]);
}
